import React, { useState, useEffect } from 'react';

const SecondsTimer = ({ initialTime, onComplete }) => {
  const [time, setTime] = useState(initialTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevTime) => prevTime - 1);

      if (time === 1) {
        clearInterval(interval);
        onComplete();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [time, onComplete]);

  return (
    <div>
      This call will be auto answered in {time} second{time !== 1 ? 's' : ''}!
    </div>
  );
};

export default SecondsTimer;
